"use client"

import { Skeleton } from "@/components/ui/skeleton"

const LatestNewsSkeleton = () => {
    return (
        <div className="w-full flex flex-col gap-5">
            <Skeleton className="sm:h-9 h-7 sm:w-48 w-32" />

            <div className="flex flex-col sm:flex-row gap-5">
                <div className="w-full sm:w-2/3">
                    <div className="relative w-full h-[400px] rounded-lg overflow-hidden">
                        <Skeleton className="w-full h-full" />
                        <div className="absolute top-[250px] sm:left-[56px] left-[10px] sm:right-[56px] right-[10px] flex flex-col sm:gap-2.5 gap-[6px]">
                            <Skeleton className="sm:h-[18.6px] h-[27.9px] sm:w-24 w-32" />
                            <Skeleton className="sm:h-[31px] h-[24.8px] w-full" />
                            <Skeleton className="sm:h-[31px] h-[24.8px] w-3/4" />
                            <Skeleton className="sm:h-[31px] h-[24.8px] w-2/3" />
                            <Skeleton className="h-[24.8px] w-32 mt-1" />
                        </div>
                    </div>
                </div>

                <div className="hidden sm:block w-full sm:w-1/3">
                    <div className="flex flex-col sm:gap-2.5 gap-[6px]">
                        <Skeleton className="w-full h-[254px] rounded-lg" />
                        <div className="flex flex-col">
                            <Skeleton className="h-[18.6px] w-20" />
                            <Skeleton className="h-[31px] w-full sm:pt-1 pt-[2px] sm:pb-2.5 pb-[5px]" />
                            <Skeleton className="h-[31px] w-3/4" />
                            <Skeleton className="h-[24.8px] w-32" />
                        </div>
                    </div>
                </div>
            </div>

            <div className="grid grid-cols-2 sm:grid-cols-3 gap-5">
                <div className="sm:hidden flex flex-col sm:gap-2.5 gap-[6px]">
                    <Skeleton className="w-full h-[160px] rounded-lg" />
                    <div className="flex flex-col">
                        <Skeleton className="h-[18.6px] w-20" />
                        <Skeleton className="h-[19.6px] w-full pt-[2px] pb-[5px]" />
                        <Skeleton className="h-[19.6px] w-3/4" />
                        <Skeleton className="h-[24.8px] w-32" />
                    </div>
                </div>

                {Array.from({ length: 3 }).map((_, index) => (
                    <div key={index} className="group flex flex-col">
                        <Skeleton className="w-full sm:h-[254px] h-[160px] rounded-lg" />
                        <div className="flex flex-col sm:gap-2.5 gap-[5px]">
                            <Skeleton className="sm:h-[18.6px] h-[18.6px] sm:w-20 w-20 sm:pt-2.5 pt-[6px] sm:pb-1 pb-[2px]" />
                            <Skeleton className="sm:h-[31px] h-[19.6px] w-full" />
                            <Skeleton className="sm:h-[31px] h-[19.6px] w-3/4" />
                            <Skeleton className="h-[24.8px] w-32" />
                        </div>
                    </div>
                ))}
            </div>
        </div>
    )
}

export default LatestNewsSkeleton
